<div class="relative w-fit" #anchorContent>
  <ng-content></ng-content>
  <div
    toggleElement
    [id]="elementId()"
    [zIndexClass]="zIndexDropdownClass()"
    [show]="show()"
    (showChange)="show.set($event)"
    [toggleByAnchor]="!isDisabled() && toggleByAnchor()"
    [anchor]="anchor() || anchorContent"
    [xAxis]="xAxis()"
    [yAxis]="yAxis()"
    [distance]="distance()"
    [closeInternalClick]="closeOnInternalClick()"
    (mouseenter)="panelMouseEnter.emit()"
    (mouseleave)="panelMouseLeave.emit()"
    class="overflow-visible py-[5px] border-radius-8 border border-solid border-border-solid shadow-lg bg-background z-10 dropdown-list"
  >
    <div class="self-stretch">
      @if (showSearchBox()) { @let placeholder = searchBoxConfig()?.placeholder ?? 'COMPONENTS.DX.SEARCH'; @let icon =
      searchBoxConfig()?.icon ?? 'fi fi-rr-search';
      <lib-input
        [withBorder]="false"
        [placeholder]="placeholder"
        class="w-full flex pb-[6px] pt-[2px] border-b-1 border-border-solid"
        [(value)]="filterText"
        [icon]="icon"
      ></lib-input>
      } @if (scrollable()) {
      <lib-scroll-area [childItemHeight]="36" [withBorder]="false">
        <ng-container *ngTemplateOutlet="container; context: { $implicit: true }"></ng-container>
      </lib-scroll-area>
      } @if (!scrollable()) {
      <div class="pt-[7px] pb-[5px]">
        <ng-container *ngTemplateOutlet="container; context: { $implicit: false }"></ng-container>
      </div>
      }

      <ng-content select="[dropdownContent]"></ng-content>
    </div>
  </div>
</div>

<ng-template #container let-isScrollable="isScrollable">
  <div [class.overflow-hidden]="isScrollable">
    @if (grouped()) { @for (group of groupedDataSource(); track $index) {
    <div>
      @for (option of group.items; track trackOption(option, $index)) {
      <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ option }"></ng-container>
      } @empty {
      <div class="flex justify-center items-center h-[36px]">
        <span class="content-sm-regular text-muted-foreground px-[16px]">
          {{ 'COMPONENTS.DX.NO_DATA' | translate }}
        </span>
      </div>
      }
    </div>
    <hr
      class="w-full my-[4px] border-t-0 border-b-1 border-solid border-border-solid hidden [&:not(:last-child)]:flex"
    />
    } } @if (!grouped()) { @for (option of filteredDataSource(); track trackOption(option, $index)) {
    <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ option }"></ng-container>
    } @empty {
    <div class="flex justify-center items-center h-[36px]">
      <span class="content-sm-regular text-muted-foreground px-[16px]">
        {{ 'COMPONENTS.DX.NO_DATA' | translate }}
      </span>
    </div>
    } }
  </div>
</ng-template>

<ng-template #content let-option="option">
  @if (!option?.hidden) {
  <div
    #tooltipDirective="libTooltip"
    lib-tooltip
    [tooltipContent]="option?.tooltip"
    [disableTooltip]="!option?.displayTooltip"
    class="relative flex items-center"
    (mouseenter)="handleMouseEnterItem(option)"
    (mouseleave)="handleMouseLeaveItem()"
  >
    <div class="flex-1 min-w-0">
      @if (itemTemplate()) {
      <div
        class="cursor-pointer"
        [class.pointer-events-none]="isDisabled() || option.disabled"
        [class.opacity-50]="isDisabled() || option.disabled"
        (click)="selectOption(option); !option.disabled && !isDisabled() && tooltipDirective.removeTooltip()"
      >
        <ng-container
          *ngTemplateOutlet="
            itemTemplate();
            context: {
              $implicit: option,
              item: option,
              selected: selectedOption?.id === option.id,
              disabled: isDisabled() || option.disabled
            }
          "
        ></ng-container>
      </div>
      } @else {
      <lib-list-item
        [displaySelectedIcon]="displaySelectedIcon()"
        [disabled]="isDisabled() || option.disabled"
        [text]="option.description"
        [secondaryText]="option.secondaryText"
        [selected]="selectedOption?.id === option.id && !(option.subItems && option.subItems.length > 0)"
        [leftIcon]="option?.leftIcon"
        [rightIcon]="option.subItems && option.subItems.length > 0 ? 'fi fi-rr-angle-small-right' : option?.rightIcon"
        [systemLeftIcon]="option?.systemLeftIcon"
        [systemRightIcon]="option?.systemRightIcon"
        [checkbox]="option?.checkbox"
        (click)="selectOption(option); !option.disabled && !isDisabled() && tooltipDirective.removeTooltip()"
      ></lib-list-item>
      }
    </div>
    @if (option.pinnable && !(option.subItems && option.subItems.length > 0)) {
    <button
      type="button"
      class="shrink-0 flex items-center justify-center p-[6px] mx-[4px] rounded-[6px] text-muted-foreground hover:text-primary hover:bg-accent-solid transition-colors"
      [class.text-primary]="option.pinned"
      [attr.aria-label]="option.pinned ? 'Unpin' : 'Pin'"
      (click)="$event.stopPropagation(); option.onPin?.(option)"
    >
      <i class="fi fi-rr-heart block text-[16px] leading-[16px]"></i>
    </button>
    }

    @if (hoveredItemWithSubItems()?.id === option.id && option.subItems && option.subItems.length > 0) {
    <div
      class="absolute top-0 w-fit min-w-[150px] border-radius-8 border border-solid border-border-solid shadow-lg bg-background z-20 py-[6px]"
      [ngClass]="{
          'left-[calc(100%_+_6px)]': subMenuPosition() === 'right',
          'right-[calc(100%_+_6px)]': subMenuPosition() === 'left',
        }"
      (mouseenter)="handleMouseEnterSubMenu()"
      (mouseleave)="handleMouseLeaveSubMenu()"
    >
      @if (grouped()) { @for (subGroup of getGroupedItems(option.subItems); track $index) { @for (subItem of
      subGroup.items; track trackOption(subItem, $index)) {
      <div
        #subGroupTooltipDirective="libTooltip"
        lib-tooltip
        [tooltipContent]="subItem?.tooltip"
        [disableTooltip]="!subItem?.displayTooltip"
      >
        <lib-list-item
          [disabled]="isDisabled() || subItem.disabled"
          [displaySelectedIcon]="displaySelectedIcon()"
          [text]="subItem.description"
          [secondaryText]="subItem.secondaryText"
          [selected]="selectedOption?.id === subItem.id"
          [leftIcon]="subItem?.leftIcon"
          [rightIcon]="subItem?.rightIcon"
          [systemLeftIcon]="subItem?.systemLeftIcon"
          [systemRightIcon]="subItem?.systemRightIcon"
          [checkbox]="subItem?.checkbox"
          (click)="
            selectOption(subItem, true); !subItem.disabled && !isDisabled() && subGroupTooltipDirective.removeTooltip()
          "
        ></lib-list-item>
      </div>
      }
      <hr
        class="w-full my-[4px] border-t-0 border-b-1 border-solid border-border-solid hidden [&:not(:last-child)]:flex"
      />
      } } @else { @for (subItem of option.subItems; track trackOption(subItem, $index)) {
      <div
        #subTooltipDirective="libTooltip"
        lib-tooltip
        [tooltipContent]="subItem?.tooltip"
        [disableTooltip]="!subItem?.displayTooltip"
      >
        <lib-list-item
          [disabled]="isDisabled() || subItem.disabled"
          [displaySelectedIcon]="displaySelectedIcon()"
          [text]="subItem.description"
          [secondaryText]="subItem.secondaryText"
          [systemLeftIcon]="subItem?.systemLeftIcon"
          [systemRightIcon]="subItem?.systemRightIcon"
          [selected]="selectedOption?.id === subItem.id"
          [leftIcon]="subItem?.leftIcon"
          [rightIcon]="subItem?.rightIcon"
          [checkbox]="subItem?.checkbox"
          (click)="
            selectOption(subItem, true); !subItem.disabled && !isDisabled() && subTooltipDirective.removeTooltip()
          "
        ></lib-list-item>
      </div>
      } }
    </div>
    }
  </div>
  }
</ng-template>
